<app-header-one></app-header-one>

<div class="page-title-area page-title-bg1">
    <div class="container">
        <div class="page-title-content">
            <h2>{{ "Contact US" | translate }}</h2>
        </div>
    </div>
</div>

<section class="contact-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-5 col-md-12">
                <div class="contact-info">
                    <h3>{{"Here to Help" | translate }}</h3>
                    <p>{{"Have a question? You may find an answer in our" | translate}} <a routerLink="/faqs">{{"FAQs" | translate}}</a>. {{"But you can also contact us" | translate}}.</p>
                    <ul class="contact-list">
                        <li><i class='bx bx-map'></i> {{"Location" | translate }}: <a href="#"></a></li>
                        <li><i class='bx bx-phone-call'></i> {{"Call Us" | translate}}: <a href="tel:+01321654214">+01 321 654 214</a></li>
                        <li><i class='bx bx-envelope'></i> {{"Email Us" | translate}}: <a href="mailto:hello@louise.com">hello@louise.com</a></li>
                        <li><i class='bx bx-microphone'></i> {{"Fax" | translate}}: <a href="tel:+123456789">+123456789</a></li>
                    </ul>
                    <h3>{{"Follow Us" | translate}}:</h3>
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-skype'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-pinterest-alt'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-youtube'></i></a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-7 col-md-12">
                <div class="contact-form">
                    <h3>{{ "Contact US" | translate }}</h3>
                    <p>{{"Contacttext" | translate}}</p>
                    <form id="contactForm">
                        <div class="row">
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group mb-3">
                                    <label>{{"Name" | translate}} <span>*</span></label>
                                    <input type="text" name="name" id="name" class="form-control" [placeholder]="'Your name' |translate">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group mb-3">
                                    <label>{{"Email" | translate}} <span>*</span></label>
                                    <input type="email" name="email" id="email" class="form-control" [placeholder]="'Your email address'|translate">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <label>{{"Phone Number" | translate}} <span>*</span></label>
                                    <input type="text" name="phone_number" id="phone_number" class="form-control" [placeholder]="'Your phone number'|translate">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <label>{{"Your Message" | translate}} <span>*</span></label>
                                    <textarea name="message" id="message" cols="30" rows="5" class="form-control" [placeholder]="'Write your message...'|translate"></textarea>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <button type="submit" class="default-btn">{{"Send Message" | translate}}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<div id="map">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2987.759347356707!2d-73.78797548425361!3d41.50948959637902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89dd490255c9bfa7%3A0xfe099945f43b6e47!2sWonderland%20Dr%2C%20East%20Fishkill%2C%20NY%2012533%2C%20USA!5e0!3m2!1sen!2sbd!4v1587654262668!5m2!1sen!2sbd"></iframe>
</div>